module.exports = __webpack_public_path__ + "media/images/test_zyvo-3e26f4d66acb0464ff94027ef131fac0.png";